var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoSystem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 127.188V145.938C0 148.531 2.09375 150.625 4.6875 150.625H23.4375V122.5H4.6875C2.09375 122.5 0 124.594 0 127.188ZM155.312 9.375H136.562V37.5H155.312C157.906 37.5 160 35.4062 160 32.8125V14.0625C160 11.4688 157.906 9.375 155.312 9.375ZM108.125 0C96.8125 0 87.3438 8.0625 85.1562 18.75L80.3125 23.4375L85.1562 28.125C87.3438 38.8125 96.8125 46.875 108.125 46.875H122.5L124.375 38.75V10L122.5 0H108.125ZM51.875 113.125H37.5L32.8125 122.188V153.125L37.5 160H51.875C63.1875 160 72.6562 151.938 74.8438 141.25L78.75 136.562L74.8438 131.875C72.6562 121.188 63.1875 113.125 51.875 113.125Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 117.812V155.312C18.75 157.906 20.8438 160 23.4375 160H37.5V113.125H23.4375C20.8438 113.125 18.75 115.219 18.75 117.812ZM136.562 0H122.5V46.875H136.562C139.156 46.875 141.25 44.7812 141.25 42.1875V4.6875C141.25 2.09375 139.156 0 136.562 0ZM84.6875 99.5C90.5312 94 94.0625 86.0938 94.0625 77.7812V64.8125C90.0625 63.4062 86.9062 60.2188 85.5 56.25H84.6875V99.5ZM75.3125 56.25H74.5C73.0938 60.25 69.9062 63.4062 65.9375 64.8125V77.7812C65.9375 86.0938 69.4688 93.9688 75.3125 99.5V56.25ZM108.125 75.3125H103.438V77.7812C103.438 80.125 103.219 82.4375 102.812 84.6875H108.125C121 84.6875 131.875 95.5625 131.875 108.438C131.875 125.062 115.5 131.875 98.75 131.875H74.8438C75.1562 133.375 75.3125 134.969 75.3125 136.562C75.3125 138.156 75.1562 139.75 74.8438 141.25H98.75C127.625 141.25 141.25 125.469 141.25 108.438C141.25 90.3125 126.281 75.3125 108.125 75.3125ZM56.5625 75.3125H51.875C38.9375 75.3125 28.4375 64.6562 28.4375 51.5625C28.4375 38.625 38.9375 28.125 51.875 28.125H85.1562C84.8438 26.625 84.6875 25.0312 84.6875 23.4375C84.6875 21.8438 84.8438 20.25 85.1562 18.75H51.875C33.7812 18.75 19.0625 33.4688 19.0625 51.5625C19.0625 69.8125 33.7812 84.6875 51.875 84.6875H57.1875C56.7812 82.4375 56.5625 80.125 56.5625 77.7812V75.3125Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.156 106.812H56.6562C54.9375 106.812 53.5312 105.406 53.5312 103.687V56.1875C53.5312 54.4687 54.9375 53.0625 56.6562 53.0625H104.156C105.875 53.0625 107.281 54.4687 107.281 56.1875V103.687C107.281 105.406 105.875 106.812 104.156 106.812Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 80,
    y1: 160,
    x2: 80,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3A84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 80,
    y1: 160,
    x2: 80,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 80.399,
    y1: 106.798,
    x2: 80.399,
    y2: 53.0483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3A84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA68D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSystem);
export default __webpack_public_path__ + "static/media/picto_system.992e81acbaa69d7cfebb2b7973a780b8.svg";
export { ForwardRef as ReactComponent };